import { useTranslation } from "react-i18next";

// Hopsy brand WhatsApp number (+91 7822086946) — wa.me expects no "+"/spaces.
const WA_NUMBER = "917822086946";

export default function WhatsAppFAB() {
  const { t } = useTranslation();
  const tooltip = t("whatsapp.tooltip");
  const msg = t("whatsapp.prefill");
  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={tooltip}
      title={tooltip}
      data-testid="whatsapp-fab"
      /* Sits to the LEFT of the Pet Care AI button (bottom-right). */
      className="fixed bottom-6 right-[5.25rem] z-50 bg-[#25D366] hover:bg-[#128C7E] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] rounded-full h-14 w-14 flex items-center justify-center transition-transform hover:scale-105"
    >
      {/* Official-ish WhatsApp glyph (lucide MessageCircle is close + safe fallback) */}
      <svg
        viewBox="0 0 32 32"
        width="26"
        height="26"
        aria-hidden="true"
        fill="currentColor"
      >
        <path d="M16.003 3.2c-7.08 0-12.83 5.75-12.83 12.83 0 2.26.59 4.47 1.71 6.41L3.2 28.8l6.53-1.71a12.79 12.79 0 0 0 6.27 1.62h.01c7.08 0 12.83-5.75 12.83-12.83 0-3.43-1.33-6.66-3.76-9.08a12.76 12.76 0 0 0-9.08-3.6Zm0 23.36h-.01a10.66 10.66 0 0 1-5.43-1.49l-.39-.23-3.88 1.02 1.03-3.78-.25-.39a10.66 10.66 0 0 1-1.63-5.68c0-5.88 4.79-10.66 10.67-10.66 2.85 0 5.53 1.11 7.54 3.13a10.62 10.62 0 0 1 3.12 7.54c0 5.88-4.79 10.66-10.67 10.66Zm5.85-7.98c-.32-.16-1.9-.94-2.19-1.05-.29-.11-.51-.16-.72.16-.21.32-.83 1.05-1.02 1.26-.19.21-.37.24-.69.08-.32-.16-1.36-.5-2.59-1.6-.96-.86-1.6-1.92-1.79-2.24-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.74-.99-2.39-.26-.62-.53-.54-.72-.55-.18-.01-.4-.01-.61-.01-.21 0-.56.08-.85.4-.29.32-1.12 1.1-1.12 2.67 0 1.58 1.15 3.1 1.31 3.31.16.21 2.26 3.45 5.48 4.84.76.33 1.36.52 1.83.67.77.24 1.47.21 2.02.13.62-.09 1.9-.78 2.17-1.53.27-.75.27-1.4.19-1.53-.08-.13-.29-.21-.61-.37Z" />
      </svg>
      <span className="sr-only">{tooltip}</span>
    </a>
  );
}
